import React, { useState } from "react";
import axios from "axios";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");

  const submit = async () => {
    const res = await axios.post("https://api.propertygalleria.in/forgot-password",{email});
    alert("Reset Token: " + res.data.resetToken);
  };

  return (
    <div className="user-container">
      <h2>Forgot Password</h2>
      <input placeholder="Enter Email" onChange={(e)=>setEmail(e.target.value)} />
      <button onClick={submit}>Send Reset Link</button>
    </div>
  );
};

export default ForgotPassword;
